<div class="main-container">
  <layout-header></layout-header>
  <kbm-messages />
  <div class="core-contents">
    <router-outlet class="content"></router-outlet>
    <!-- Routed views will end up here -->
  </div>
</div>